import { observer } from 'mobx-react-lite';
import React, { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useStores } from 'src/components/store';
import { MainPages, ProtectionMenuNameOptions, WebFilteringSubMenu } from 'src/utils/enums';
import { convertEnumToDropdownItems, DropdownMenu } from 'src/components/shared/dropdown-menu/dropdown-menu';
import './web-filtering.scss';

export const WebFiltering: React.FC = observer(() => {
    const { fwVersionStore, uiStore, customerStore } = useStores();

    useEffect(() => {
        fwVersionStore.setProtectionType(ProtectionMenuNameOptions.WEB_FILTERING);
        uiStore.sendPageViewEvent(MainPages.POLICY, ProtectionMenuNameOptions.WEB_FILTERING);
    }, []);

    const values = useMemo(() => {
        const dropdownItems = convertEnumToDropdownItems(WebFilteringSubMenu);
        const domainsItem = dropdownItems.find(_ => _.value === WebFilteringSubMenu.DOMAINS);
        if (domainsItem) {
            domainsItem.label = 'Domains / DNS';
        }
        return dropdownItems;
    }, [customerStore.selectedLocation?.serviceLevel]);

    return <div className="web-filtering" data-testid="web-filtering">
        <DropdownMenu items={values} activeSubMenu={fwVersionStore.webFilteringType} />
        <div className="page-content" data-testid="page-content">
            <Outlet />
        </div>
    </div>;
});
